import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=5621a9ec&scoped=true&lang=true&"
import script from "./Teachers.vue?vue&type=script&lang=js&"
export * from "./Teachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5621a9ec",
  null
  
)

export default component.exports